import { render, staticRenderFns } from "./AutoRunPointValConfigForm.vue?vue&type=template&id=0f636f52&"
import script from "./AutoRunPointValConfigForm.vue?vue&type=script&lang=js&"
export * from "./AutoRunPointValConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports